import Helpers from '../helpers';

import { CountUp } from 'countup.js';

export default class Counter {
  static init(counterElement) {
    const scrollListener = () => {
      if (Helpers.isElementInViewport(counterElement)) {
        new CountUp(counterElement, counterValue, options).start();

        window.removeEventListener('scroll', scrollListener);
      }
    };

    const counterValue = Number(counterElement.getAttribute('data-aui-counter'));
    const initMode = counterElement.getAttribute('data-aui-counter-init');
    const prefix = counterElement.getAttribute('data-aui-counter-prefix');
    const suffix = counterElement.getAttribute('data-aui-counter-suffix');

    const options = {
      separator: ' ',
      ...(prefix !== null && { prefix }),
      ...(suffix !== null && { suffix }),
    };

    if (isNaN(counterValue)) {
      return;
    }

    if (initMode === 'view') {
      let countUp = null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            countUp = new CountUp(counterElement, counterValue, options);
            countUp.start();
          } else if (countUp) {
            countUp.reset();
          }
        });
      });

      observer.observe(counterElement);

      return;
    }

    new CountUp(counterElement, counterValue, options).start();
  }
}